import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import BackToTop from "./components/feature/BackToTop";
import FloatingCTA from "./components/feature/FloatingCTA";
import CookieBanner from "./components/feature/CookieBanner";
import GlobalSEO from "./components/feature/GlobalSEO";
import { useEffect } from "react";

const ORIGINAL_TITLE = "Inkopen uit China | Sourcing Agent & Import Service | Direct Uit China (DUC)";
const AWAY_TITLE = "Koop direct goedkoper in uit China | DUC";

function TabTitleEffect() {
  useEffect(() => {
    const handleVisibility = () => {
      document.title = document.hidden ? AWAY_TITLE : ORIGINAL_TITLE;
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <GlobalSEO />
        <TabTitleEffect />
        <ScrollToTop />
        <AppRoutes />
        <BackToTop />
        <FloatingCTA />
        <CookieBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
